import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-web-tirewarranty-shared-ui-thankyou',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './lib-thankyou.component.html',
  styleUrl: './lib-thankyou.component.scss'
})
export class LibThankyouComponent {
  
  readonly router = inject(Router);

  goBack() {
    this.router.navigate(['/']);
  }
}
